import * as React from 'react';

import { fromJson } from '@bufbuild/protobuf';
import {
  DriverCertificationEvent,
  DriverCertificationEventSchema,
} from '@rematter/frontend-lib-api-client/grpc/transportation/v1/driver_certification_events_pb';
import { Col, EventDetailContainer, JsonViewer } from '@rematter/ui-web';

import { DriverCertificationAddedDetail } from './DriverCertificationAddedDetail';
import { DriverCertificationDeletedDetail } from './DriverCertificationDeletedDetail';
import { DriverCertificationUpdatedDetail } from './DriverCertificationUpdatedDetail';

type DriverCertificationEventDetailProps = {
  payload: string;
};

export const DriverCertificationEventDetail = ({
  payload,
}: DriverCertificationEventDetailProps) => {
  const [showJson, setShowJson] = React.useState(false);

  const event = React.useMemo((): DriverCertificationEvent | null => {
    try {
      return fromJson(DriverCertificationEventSchema, JSON.parse(payload));
    } catch {
      return null;
    }
  }, [payload]);

  if (!event) {
    return <JsonViewer data={payload} title="Raw Payload (Parse Error)" />;
  }

  const { event: inner } = event;

  const renderEventContent = () => {
    switch (inner.case) {
      case 'created':
        return <DriverCertificationAddedDetail event={inner.value} />;
      case 'updated':
        return <DriverCertificationUpdatedDetail event={inner.value} />;
      case 'deleted':
        return <DriverCertificationDeletedDetail event={inner.value} />;
      case undefined:
        return <JsonViewer data={payload} title="Unknown Event Type" />;
    }
  };

  const getEventTitle = (): string => {
    switch (inner.case) {
      case 'created':
        return 'Driver Certification Created';
      case 'updated':
        return 'Driver Certification Updated';
      case 'deleted':
        return 'Driver Certification Deleted';
      case undefined:
      default:
        return 'Unknown Event';
    }
  };

  return (
    <Col className="@DriverCertificationEventDetail flex-1">
      <EventDetailContainer
        title={getEventTitle()}
        showJson={showJson}
        onToggleJson={() => setShowJson(!showJson)}
        jsonContent={payload}
      >
        {renderEventContent()}
      </EventDetailContainer>
    </Col>
  );
};
